import { useRequestEvent } from 'nuxt/app';
import type { AwPerf } from 'awServerModule/runtime/server/serverUtil/awPerf';

/** Returns the `awPerf` attached to the H3 event when the debug timer is enabled. */
export function useAwPerf (): AwPerf | undefined {
  if (!import.meta.server) {
    return undefined;
  }
  return useRequestEvent()?.context?.awPerf;
}
